"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadAndApplyCarbon = exports.loadCarbon = exports.loadResource = exports.useConfig = void 0;
const carbon_1 = require("./carbon");
const resource_1 = __importDefault(require("./resource"));
const types_1 = require("./types");
let config = {
    baseURL: "",
};
/**
 * Set the global Config object to use for API calls
 * @param newConfig Config object
 */
function useConfig(newConfig) {
    config = newConfig;
}
exports.useConfig = useConfig;
/**
 * Fetch a Resource
 * @param resourceId Resource identifier
 * @returns Resource
 */
function loadResource(resourceId) {
    const url = `${config.baseURL}/resource/${resourceId}/glowbinary?cachedOnly=1`;
    return fetch(url, {
        headers: Object.assign(Object.assign(Object.assign({}, config.applicationId && { applicationId: config.applicationId }), config.token && { token: config.token }), config.basicAuthKeys && { Authorization: `Basic ${config.basicAuthKeys}` }),
    })
        .then((response) => {
        if (response.status === 200) {
            return response.arrayBuffer();
        }
        else {
            throw response;
        }
    })
        .then((response) => {
        return resource_1.default.fromArrayBuffer(resourceId, response);
    });
}
exports.loadResource = loadResource;
/**
 * Fetch the specified carbon resource
 * @param carbonRegion Region code
 * @param carbonMix Mix (select energy source)
 * @returns Resource with carbon data
 */
function loadCarbon(carbonRegion, carbonMix = types_1.CarbonMix.INTENSITY) {
    return loadResource((0, carbon_1.carbonRegionResourceId)(carbonRegion, carbonMix));
}
exports.loadCarbon = loadCarbon;
/**
 * Fetch and immediately apply specified carbon to a resource
 * @param carbonRegion Region code
 * @param carbonMix Mix (select energy source)
 * @returns Resource with carbon data
 */
function loadAndApplyCarbon(existingResource, carbonRegion, carbonMix = types_1.CarbonMix.INTENSITY) {
    return __awaiter(this, void 0, void 0, function* () {
        const carbon = yield loadCarbon(carbonRegion, carbonMix);
        return existingResource.apply({
            baseline: carbon,
            func: types_1.ApplyFunction.MULTIPLY,
        });
    });
}
exports.loadAndApplyCarbon = loadAndApplyCarbon;
//# sourceMappingURL=server.js.map